__turbopack_context__.v({
  "className": "nunito_sans_1534b024-module__d2sOWG__className",
  "variable": "nunito_sans_1534b024-module__d2sOWG__variable",
});
